import * as React from 'react';

interface Props {
  width?: string;
  height?: string;
  viewBox: string;
  children: React.ReactNode;
  fill?: string;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const SVGIcon: React.FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox={props.viewBox}
      width={props.width}
      height={props.height}
      fill={props.fill}
      className={props.className}
      version="1.1"
      aria-hidden={props.ariaHidden}
      aria-label={props.ariaLabel}
    >
      {props.children}
    </svg>
  );
};

export default SVGIcon;
